import { APP_PATHS } from 'app-shared/constants';
import { Navigate, useLocation } from 'react-router-dom';

// Opens the sign-in page, and Clerk brings the person back here afterwards.
// A plain navigation rather than Clerk's RedirectToSignIn: React runs effects
// twice in development, and Clerk's redirect then nested the sign-in page
// into the return address, leaving people on an empty sign-in page.
export const ClerkSignInRedirect = () => {
  const location = useLocation();
  const returnUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

  return (
    <Navigate
      to={{
        pathname: APP_PATHS.signIn,
        search: new URLSearchParams({ redirect_url: returnUrl }).toString(),
      }}
      replace
    />
  );
};
